import React, {useEffect, useState} from "react";
import {CssBaseline, Grid} from '@material-ui/core';

import {getPlacesData} from './api';

import Header from './components/Header/Header';
import List from './components/List/List';
import Map from './components/Map/Map';

const App = () => {

    const [places, setPlaces] = useState([]);
    const [filteredPlaces, setFilteredPlaces] = useState([]);

    const [childClicked, setChildClicked] = useState(null)

    const [coordinates, setCoordinates] = useState({});
    const [bounds, setBounds] = useState({});

    const [isLoaading, setIsLoaading] = useState(false);
    
    const [type, setType] = useState('restaurants');
    const [rating, setRating] = useState('');

    useEffect(() => {
        navigator.geolocation.getCurrentPosition(({coords: {latitude, longitude}}) => {
            setCoordinates({lat: latitude, lng: longitude});
        })
        }, []);

       
    useEffect(() => {
        const filteredPlaces = places.filter((place) => place.rating > rating)
        setFilteredPlaces(filteredPlaces);
        //eslint-disable-next-line      
    }, [rating]);

        useEffect(() => {
            //console.log(coordinates, bounds);
            
            if (bounds.sw && bounds.ne) {
                setIsLoaading(true);
                getPlacesData(type, bounds.sw, bounds.ne)
                .then((data) => {
                  setPlaces(data && data.filter((places) => places.name && places.num_reviews > 0));
                  setFilteredPlaces([]);
                  setIsLoaading(false);
                })
                .catch((error) => {
                  console.log(error);
                });
            }
          }, [type, bounds]);

          console.log(places);
          console.log(filteredPlaces);
    

    return (
        <React.Fragment>
        <CssBaseline />
                <Header setCoordinates={setCoordinates}/>
                <Grid container spacing={3} style={{width:'100%'}}>
                    <Grid item xs={12} md={4}>
                        <List 
                            places={filteredPlaces.length ? filteredPlaces : places}
                            childClicked={childClicked}   
                            isLoaading={isLoaading}
                            type={type}
                            setType={setType}
                            rating={rating}
                            setRating={setRating} 
                        />
                    </Grid>
                    <Grid item xs={12} md={8}>
                        <Map 
                            setCoordinates={setCoordinates}
                            setBounds={setBounds}
                            coordinates={coordinates}
                            places={filteredPlaces.length ? filteredPlaces : places}
                            setChildClicked={setChildClicked}
                        />
                    </Grid>
                </Grid>
        </React.Fragment>
    )
}

export default App;